const setOpenLicences = (state) => (openLicences) => ({
  ...state,
  openLicences,
});

export default setOpenLicences;
